import React from "react";
import { Modal } from "react-bootstrap";
import "./modal.css";
import { ShimmerText } from "react-shimmer-effects";

const DisclaimerModal = ({
  showDisclaimerModal,
  disclaimerModalState,
  resetDisclaimerModalState,
}) => {
  return (
    <Modal
      centered
      className="cfd-disclaimer-modal"
      size="lg"
      backdrop="static"
      show={showDisclaimerModal}
      onHide={resetDisclaimerModalState}
    >
      <Modal.Header closeButton>
        <Modal.Title className="cfd-modal-title">Disclaimers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {disclaimerModalState.isLoading ? (
          <div className="text-center">
            <ShimmerText line={2} gap={10} />
          </div>
        ) : disclaimerModalState.error ? (
          <div className="text-center text-danger p-5">
            <p>{disclaimerModalState.error}</p>
          </div>
        ) : disclaimerModalState.disclaimerData ? (
          <ol style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
            {disclaimerModalState.disclaimerData
              .filter((data) => data)
              .map((data, index) => (
                <li
                  key={index}
                  style={{ display: "list-item", paddingBottom: "12px" }}
                >
                  {data}
                </li>
              ))}
          </ol>
        ) : (
          <div className="text-center">
            <p>No disclaimers available.</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center align-items-center">
        <button
          className="btn btn-sm btn-thm cfd-btn-thm center disclaimer-btn"
          onClick={resetDisclaimerModalState}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DisclaimerModal;
